import React from 'react';
import styled from 'styled-components';
import {mediaQueries} from '../shared/config';


const Container = styled.div`
    margin: auto;
    width: 70%;
    padding-bottom: 20px;
    z-index: 999;

    ${mediaQueries.tablet} {
        width: 80%;
	  }
`

const Image = styled.img`
    width:100%;
    border-radius: 16px;
`

const Creds = styled.div`
    width: 100%;
    font-family: 'Playfair Display';
    font-style: italic;
    font-size: 14px;
    text-align: right;
    color: white; 
    ${mediaQueries.tablet} {
        font-size: 7px;
	  }
`

export default function ImageWithCreds(props)
{
    return (
        <Container>
            <Image src={props.src}/>
            <Creds>
                {props.name}
            </Creds>
        </Container>
    )

}